import CustomMultiSelect from "./multi-select.js";
import NotFound from "../../assets/no-addition-found.svg";
import Button from "./button.js";
import {useState} from "react";

function AdditionsMultiSelect({ onAddClick, onModalClose, ...props }) {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    
    function handleAddClick() {
        onAddClick()
        setMenuIsOpen(false);
    }
    
    function handleMenuClose() {
        setMenuIsOpen(false);
        // Ensure onModalClose is called when the menu is closed
        if (onModalClose && typeof onModalClose === 'function') {
            onModalClose();
        }
    }
    
    return (
        <CustomMultiSelect
            {...props}
            menuIsOpen={menuIsOpen}
            onMenuOpen={() => setMenuIsOpen(true)}
            onMenuClose={handleMenuClose}
            noOptionsMessage={() => (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "8px",
                    }}
                >
                    <img src={NotFound} alt="not found" style={{ width: "44px", height: "44px" }} className="dark:invert dark:opacity-80"/>
                    <div className="text-gray-700 dark:text-[#c9d1d9]">Այս պահին դուք չունեք ավելացվախ ոչ մի հավելում</div>

                    <Button
                        type="button"
                        variant="primary"
                        size="sm"
                        className="mb-2 mt-4"
                        onClick={handleAddClick}
                    >
                        + Ավելացնել Հավելում
                    </Button>
                </div>
            )}
        />
    );
}

export default AdditionsMultiSelect;